export default class AdjustStatement {
  constructor() {
    this.ttl = document.querySelector(".statement_ttl");
    this.txt = document.querySelector(".statement_txt");
    if (!this.ttl || !this.txt) return;

    this.init();
  }

  init() {
    this.adjustMargin();
    window.addEventListener("resize", () => {
      this.adjustMargin();
    });

    this.ttlInner = this.ttl.querySelector(".topMv_ttl");
    window.addEventListener("scroll", () => {
      this.parallax();
    });
  }

  parallax() {
    // SP版はパララックスしない
    if (window.innerWidth <= 768) {
      if (this.ttlInner) this.ttlInner.style.transform = "";
      return;
    }
    if (!this.ttlInner) return;

    const parent = this.ttl.parentElement;
    if (!parent) return;

    const parentRect = parent.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    // パララックス開始のしきい値
    // 動き始めるタイミングを下記の数値で調整
    const threshold = windowHeight * 2.3;

    if (parentRect.bottom < threshold) {
      // 閾値を超えたスクロール量
      const diff = threshold - parentRect.bottom;

      // 進行度を計算（0.0 〜 1.0）
      let progress = diff / threshold;
      if (progress > 1) progress = 1;

      // イージング（二次曲線）：最初はゆっくり、徐々に加速する
      const easedProgress = Math.pow(progress, 2);

      // 最大移動量
      const maxMove = threshold * 0.7;

      // イージングを適用した移動量
      const moveY = maxMove * easedProgress;

      this.ttlInner.style.transform = `translateY(-${moveY}px)`;
    } else {
      this.ttlInner.style.transform = "translateY(0)";
    }
  }

  adjustMargin() {
    // mdブレークポイント(768px以下)の時のみJSで調整
    if (window.innerWidth <= 768) {
      const windowHeight = window.innerHeight;

      // 1. タイトルの初期位置リセットと高さ取得
      this.ttl.style.marginTop = "";
      const titleHeight = this.ttl.offsetHeight;

      // 2. 画面が縦長でタイトルが上に行き過ぎる場合の調整
      // タイトルのページ最上部からの絶対Y座標を取得
      const ttlRect = this.ttl.getBoundingClientRect();
      const absoluteTop = ttlRect.top + window.scrollY;

      // タイトルを画面中央（タイトルの中心が画面の中心）に配置するための目標Y座標
      const targetTop = windowHeight / 2 - titleHeight / 2;

      // 本来の位置が目標位置よりも上にある（＝画面が広くて上に行き過ぎている）場合、margin-topで押し下げる
      let finalAbsoluteTop = absoluteTop;
      if (absoluteTop < targetTop) {
        this.ttl.style.marginTop = `${targetTop - absoluteTop}px`;
        finalAbsoluteTop = targetTop;
      }

      // 3. テキストの margin-top の計算
      // 基準とする「タイトルの見た目のY座標」を決定する
      let visibleTop = finalAbsoluteTop;

      // 初期状態でタイトルが画面外（下）にある場合は、スクロールして画面中央(50vh)に来た時を基準とする
      if (visibleTop > windowHeight) {
        visibleTop = windowHeight / 2;
      }

      // テキストの上端がちょうど画面の下端(windowHeight)に配置されるように計算
      // 公式: タイトルの位置 + タイトルの高さ + margin-top = 画面の下端
      let marginTop = windowHeight - visibleTop - titleHeight;

      // 計算結果が小さすぎるとタイトルと近すぎて見えてしまうため、最低でも 80px 以上の余白を担保する
      if (marginTop < 80) marginTop = 80;

      this.txt.style.marginTop = `${marginTop}px`;
    } else {
      // PC版はCSSの設定に任せるためインラインスタイルをリセット
      this.ttl.style.marginTop = "";
      this.txt.style.marginTop = "";
    }
  }
}
